export default "__VITE_ASSET__BkbbMF9V__"